import { alpha } from '@mui/material/styles';

export default theme => ({
    // Full-width fixed wrapper pinned to the bottom of the viewport. Centering
    // is done with flex here (not a transform on the bar) because MUI `Slide`
    // owns the bar's `transform` for the slide-up animation — a transform-based
    // horizontal offset would be dropped once the animation settles, leaving
    // the bar off-centre. `pointerEvents: none` lets clicks pass through the
    // transparent gutters either side of the bar. Consumers can override the
    // wrapper via `className` (e.g. set `left` to offset for a fixed sidebar).
    root: {
        position: 'fixed',
        bottom: theme.spacing(3),
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(0, 3),
        pointerEvents: 'none',
        zIndex: theme.zIndex.snackbar,
    },
    bar: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        padding: theme.spacing(1.5, 2),
        // Wide bar spanning most of the content column, capped so it stays
        // comfortably centred on large viewports.
        width: '100%',
        maxWidth: 900,
        borderRadius: theme.shape.borderRadius * 2,
        border: `1px solid ${theme.palette.divider}`,
        // Elevated surface so the bar reads as floating over the content.
        boxShadow: theme.shadows[6],
        pointerEvents: 'auto',
    },
    // Pulsing primary dot that draws the eye to the pending-changes state.
    dot: {
        flexShrink: 0,
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main,
        animation: '$pulse 1.6s ease-in-out infinite',
    },
    '@keyframes pulse': {
        '0%': {
            boxShadow: `0 0 0 0 ${alpha(theme.palette.primary.main, 0.5)}`,
        },
        '70%': {
            boxShadow: `0 0 0 6px ${alpha(theme.palette.primary.main, 0)}`,
        },
        '100%': {
            boxShadow: `0 0 0 0 ${alpha(theme.palette.primary.main, 0)}`,
        },
    },
    text: {
        color: theme.palette.text.primary,
        fontSize: 14,
    },
    actions: {
        flexShrink: 0,
    },
});
